import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'contentVisibility',
})
export class ContentVisibilityPipe implements PipeTransform {
  private translate = inject(TranslateService);


  transform(hidden: boolean): string {
    return this.translate.instant(hidden ? 'contents.hidden' : 'contents.visible');
  }
}
